// extracted by mini-css-extract-plugin
export default {"container":"MediaImageControls_container__UKvsw","autoRotate":"MediaImageControls_autoRotate__cA+K3","fullScreen":"MediaImageControls_fullScreen__859A1"};